import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu2',
  templateUrl: './menu2.component.html',
  styleUrls: ['./menu2.component.scss']
})
export class Menu2Component implements OnInit {

  constructor(public router: Router) { }
  cliente;
  usuario;
  ngOnInit() {
    this.cliente=localStorage.getItem("nom_cliente");
    this.usuario=localStorage.getItem("sufijo");
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
}
